import {Injectable, NgZone} from '@angular/core';
import {Keepalive} from "@ng-idle/keepalive";
import {DEFAULT_INTERRUPTSOURCES, Idle} from "@ng-idle/core";
import {environment} from "../../environments/environment";
import { HttpHeaders, HttpRequest } from "@angular/common/http";
import {
  DialogData,
  IdleWarningModalComponent
} from "../components/shared/modals/idle-warning-modal/idle-warning-modal.component";
import {AuthService} from "./auth.service";
import {Session} from "./session.service";
import {MatDialog, MatDialogRef, MatDialogState} from "@angular/material/dialog";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class IdleWatcherService {
  expiredSession = false;
  modalRef: MatDialogRef<any>;

  constructor(private idle: Idle,
              private keepalive: Keepalive,
              private authService: AuthService,
              private session: Session,
              private router: Router,
              public Dialog: MatDialog,
              private ngZone: NgZone,) {
    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(2700);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(900);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    //console.log("testing idle watcher service");

    idle.onIdleEnd.subscribe(() => {
      //this.idleState = 'No longer idle.';
      if (this.modalRef && this.modalRef.getState() === MatDialogState.OPEN) {
        this.ngZone.run(() => {
          this.modalRef.close()
        })
      }
    });

    idle.onInterrupt.subscribe(() => {
      session.renewSessionExpireTime();
    })

    //idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!'; );
    idle.onTimeoutWarning.subscribe((countdown) => {
      //get current route name from Angular router
      const routeName = this.router.url;
      console.log(routeName)
      if(routeName.includes('/assessment/workspace')){
      /*if (routeName === "AssessmentWorkspaceComponentState"
        || routeName === "ProjectOutcomeViewState"
        || routeName === "designViewState") {*/
        //We are forcing the logout because the user's sessions keeps updating in assessment workspace because of the heartbeat
        /*this.apiCall.getData('/aeAMSlogoutUser/', {})
          .subscribe((response) => {
            if(response.success){
              this.session.logoutUser();
            }
          }, (error) => {
            this.session.logoutUser();
          });*/
        this.router.navigate(['/projects']);
        return;
      }
      const modalOptions: DialogData = {
        countdown: countdown,
        expiredSession: this.expiredSession
      };
      if (!this.modalRef || this.modalRef.getState() !== MatDialogState.OPEN) {
        this.openDialog(modalOptions);
      }
      else {
        this.modalRef.componentInstance.data = modalOptions;
      }
    });
    idle.onTimeout.subscribe(() => {
      this.expiredSession = true;
      const modalOptions = {
        expiredSession: true,
        countdown: 0,
      };
      if (!this.modalRef || this.modalRef.getState() !== MatDialogState.OPEN) {
        this.openDialog(modalOptions);
      }
      else {
        this.modalRef.componentInstance.data = modalOptions;
      }
    });

    // sets the ping interval to 15 seconds
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      }),
      withCredentials: true
    }
    let httpRequest = new HttpRequest("GET", environment.apiUrl + '/aeAMSreturnSuccess', {
      headers: httpOptions.headers,
      withCredentials: true
    });
    keepalive.request(httpRequest);
    keepalive.interval(1800);
    keepalive.onPing.subscribe(() => {
      session.renewSessionExpireTime();
    });
    if (authService.isAuthenticated()) {
      idle.watch();
    } else {
      idle.stop();
    }
  }

  watch() {
    this.idle.watch();
  }

  stop(){
    this.idle.stop();
  }

  openDialog(modalOptions: DialogData) {
    this.modalRef = this.Dialog.open(IdleWarningModalComponent, {
      data: modalOptions
    })
  }
}
